var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewspaperLine = function SvgNewspaperLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 16V4H4v11.25a.75.75 0 0 0 .75.75zm2.25 1.5H4.75a2.25 2.25 0 0 1-2.25-2.25v-12a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 .75.75V8.5h3v6.75a2.25 2.25 0 0 1-2.25 2.25M14.5 10v5.25a.75.75 0 1 0 1.5 0V10zm-9-4.5H10V10H5.5zM7 7v1.5h1.5V7zm-1.5 3.75h6v1.5h-6zm0 2.25h6v1.5h-6z"
  })));
};
export default SvgNewspaperLine;